/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InvitationsInputs */

const th_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำเชิญ`)
};

const en_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

const ja_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待`)
};

const zh_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请`)
};

const es_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitaciones`)
};

const pt_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convites`)
};

const id_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undangan`)
};

const fr_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

const tl_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga paanyaya`)
};

const vi_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lời mời`)
};

const ko_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대`)
};

const de_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen`)
};

const ru_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашения`)
};

const tr_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davetler`)
};

const it_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviti`)
};

const pl_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproszenia`)
};

const uk_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрошення`)
};

const hi_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण`)
};

const ar_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدعوات`)
};

const ms_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemputan`)
};

const bn_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ`)
};

const zh_tw2_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請`)
};

const zh_hk2_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請`)
};

const ur_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوتیں`)
};

const fa_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت‌ها`)
};

const sw_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mialiko`)
};

const nl_invitations = /** @type {(inputs: InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingen`)
};

/**
* | output |
* | --- |
* | "Invitations" |
*
* @param {InvitationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invitations = /** @type {((inputs?: InvitationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InvitationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invitations(inputs)
	if (locale === "ja") return ja_invitations(inputs)
	if (locale === "zh") return zh_invitations(inputs)
	if (locale === "es") return es_invitations(inputs)
	if (locale === "pt") return pt_invitations(inputs)
	if (locale === "id") return id_invitations(inputs)
	if (locale === "fr") return fr_invitations(inputs)
	if (locale === "tl") return tl_invitations(inputs)
	if (locale === "vi") return vi_invitations(inputs)
	if (locale === "ko") return ko_invitations(inputs)
	if (locale === "de") return de_invitations(inputs)
	if (locale === "ru") return ru_invitations(inputs)
	if (locale === "tr") return tr_invitations(inputs)
	if (locale === "it") return it_invitations(inputs)
	if (locale === "pl") return pl_invitations(inputs)
	if (locale === "uk") return uk_invitations(inputs)
	if (locale === "hi") return hi_invitations(inputs)
	if (locale === "ar") return ar_invitations(inputs)
	if (locale === "ms") return ms_invitations(inputs)
	if (locale === "bn") return bn_invitations(inputs)
	if (locale === "zh-TW") return zh_tw2_invitations(inputs)
	if (locale === "zh-HK") return zh_hk2_invitations(inputs)
	if (locale === "ur") return ur_invitations(inputs)
	if (locale === "fa") return fa_invitations(inputs)
	if (locale === "sw") return sw_invitations(inputs)
	if (locale === "nl") return nl_invitations(inputs)
	return en_invitations(inputs)
});